import React, { useState } from "react";

const EmployeeFAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const FAQs = [
        {
            question: "How does Doctors Jobs help us hire faster?",
            answer: [
                "We combine programmatic sourcing with curated recommendations from verified doctors. You get an inbox of quality applicants without spending time chasing agencies."
            ],
        },
        {
            question: "Can I post roles for free?",
            answer: [
                "Yes. Your first job listing is free. Upgrade to a hiring plan when you're ready to scale, with pricing designed to keep your recruitment budget efficient."
            ],
        },
        {
            question: "How are candidates verified?",
            answer: [
                "Every doctor on our platform is HPCSA verified. Profiles include key experience, years practicing, and interest areas so you can hire confidently."
            ],
        },
        {
            question: "Do you support hard-to-fill or locum roles?",
            answer: [
                "Absolutely. We help facilities hire across primary care, specialist, locum, and emerging roles like telemedicine or healthtech leadership."
            ],
        },
        {
            question: "What if we already have an ATS?",
            answer: [
                "Use Doctors Jobs to source and qualify talent, then move shortlisted candidates into your ATS. Our pipeline manager also works as a light ATS if you need it."
            ],
        },
    ];

    return (
        <>
        <style>{`
            @media (max-width: 768px) {
                .employee-faq-heading {
                    font-size: 24px !important;
                }
            }
        `}</style>
        <section id="employee-faq" className="py-12" style={{ backgroundColor: "#f2f6ff", fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}>
            <div className="container mx-auto px-4 sm:px-6 lg:px-12">
                <div className="flex flex-col sm:flex-col md:flex-row">
                    <div className="md:w-1/3 mb-8 md:mb-0">
                        <h2 className="text-4xl font-bold mb-4 text-[#333333] employee-faq-heading">Frequently asked questions</h2>
                    </div>

                    <div className="space-y-4 md:w-2/3">
                        {FAQs.map((faq, index) => (
                            <div
                                key={index}
                                className="bg-white border-b border-gray-200 overflow-hidden rounded-lg p-4"
                            >
                                <button
                                    className="w-full text-left py-2 text-lg font-medium text-black flex justify-between items-center focus:outline-none"
                                    onClick={() => toggleAccordion(index)}
                                >
                                    {faq.question}
                                    <span className="ml-2">
                                        {openIndex === index ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5 text-black"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5 10a1 1 0 011.707-.707L10 12.586l3.293-3.293A1 1 0 0114.707 10l-4 4a1 1 0 01-1.414 0l-4-4A1 1 0 015 10z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5 text-black"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M7 10a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z"
                                                    clipRule="evenodd"
                                                />
                                                <path
                                                    fillRule="evenodd"
                                                    d="M10 3a1 1 0 011 1v4a1 1 0 11-2 0V4a1 1 0 011-1z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        )}
                                    </span>
                                </button>
                                {openIndex === index && (
                                    <div className="pt-2 pb-2 text-gray-700">
                                        {faq.answer.map((paragraph, i) => (
                                            <p key={i} className="mb-2">
                                                {paragraph}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};

export default EmployeeFAQSection;

